angular.module('iqxCore')
.controller('actionDialogDetailsCtrl', function ($scope, FormSvc, QuestionnaireSvc) {

	switch ($scope.actiondialogparams.type) {
		case 'Person':
		  FormSvc.setOptions($scope,{
		    fetchAPI:'callresult/netcandidateprofile?pPersonID='+$scope.actiondialogparams.linkID,
		    dateFields:['DOB'],
		    saveAPI:'call/NetCandidateProfileSet',
		    savePrefix:'p',
		    primaryKey:'PersonID',
		    questionnaire:{
		      tagTarget:'tags',
		      tagLocation:'P',
		      id:$scope.actiondialogparams.linkID,
		      postVar:'qanswers',
          displayGroup:'?CANDIDATE'
		     }
		  })
		break;

		case 'Contact':
		  FormSvc.setOptions($scope,{
		    fetchAPI:{},
		    questionnaire:{
		      tagTarget:'tags',
		      tagLocation:'E',
		      id:$scope.actiondialogparams.linkID,
		      postVar:'qanswers',
          displayGroup:'?CONTACT'
		      }
		    })
		break;

		case 'Company':
		  FormSvc.setOptions($scope,{
		    fetchAPI:{},
		    questionnaire:{
		      tagTarget:'tags',
		      tagLocation:'C',
		      id:$scope.actiondialogparams.linkID,
		      postVar:'qanswers',
          displayGroup:'?CLIENT'
		      }
		    })
		break;
		default:
			FormSvc.alert(false, "Sorry, there are no details available.", "info")
		break;
	}

	$scope.doUpdate=function () {
		$scope.theRecord.personid=$scope.actiondialogparams.linkID
    	FormSvc.setSubmitted($scope,true)
    	return FormSvc.update($scope, false, false)  // Do not do the fetch if submitted
    	.then(function() {
    	  FormSvc.alert("Saved", "The candidates details have been updated.", "success")
    	})
	}

	$scope.update=$scope.doUpdate
	$scope.fetch()
})
